export default {
      id: "power-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#power",
      toString: function () {
        return this.url;
      }
    }